export class Comment {
  id: string;
  text: string;
  fromDate: number;
  toDate: number;
  endPointId: string;
  dateCreated: number;
}
